function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f9f9f9;\r\n        stroke: #626a84;\r\n        stroke-width: 3px;\r\n      }\r\n    \r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Exclamation_Mark",
  "data-name": "Exclamation Mark",
  transform: "translate(-254 -307)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_493",
  "data-name": "Rectangle 493",
  className: "cls-1",
  transform: "translate(300 307) rotate(45)"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "none",
  width: 65.054,
  height: 65.054,
  rx: 12
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: 1.5,
  y: 1.5,
  width: 62.054,
  height: 62.054,
  rx: 10.5
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_400",
  "data-name": "Path 400",
  fill: "#626a84",
  d: "M2.424-52.892c0-2.171-1.837-3.4-4.007-3.4-2.282,0-4.063,1.224-4.063,3.4,0,6.623.779,16.141.779,22.764,0,1.725,1.5,2.449,3.284,2.449,1.336,0,3.228-.724,3.228-2.449C1.644-36.751,2.424-46.269,2.424-52.892ZM-1.528-23.839a4.252,4.252,0,0,0-4.286,4.286,4.287,4.287,0,0,0,4.286,4.286A4.35,4.35,0,0,0,2.7-19.553,4.313,4.313,0,0,0-1.528-23.839Z",
  transform: "translate(301.814 388.287)"
}));

var SvgMark = function SvgMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mark.a4b7d9a1.svg";
export { ForwardRef as ReactComponent };